<template>
	<svg xmlns="http://www.w3.org/2000/svg" :viewBox="viewBoxAddWidth">
		<g :fill="color">
			<polygon points="0 0 3.3 3 3.3 0 0 0" />
			<rect x="3.2" y="0.01" :width="width" height="3" />
			<polygon :points="polygonPointsAddWidth" />
		</g>
	</svg>
</template>

<script>
export default {
	name: 'kurehaArrow',
	props: {
		width: {
			type: [Number],
			default: 20,
		},
		color: {
			type: String,
			default: 'currentColor',
		},
	},
	data: function () {
		return {
			polygonPointsAddWidth: '0 20 13.1 3 13.1 0 21 0 5.5 20 0 20',
			viewBoxAddWidth: '0 0 21 20',
		};
	},
	mounted: function () {
		// const polygonPointList = `${0 + this.$props.width} 20 ${13.1 + this.$props.width} 3 ${13.1 + this.$props.width} 0 ${21 + this.$props.width} 0 ${5.5 + this.$props.width} 20 ${0 + this.$props.width} 20`;
		const polygonPointList = `${-10 + this.$props.width} 20 ${
			3.1 + this.$props.width
		} 3 ${3.1 + this.$props.width} 0 ${11 + this.$props.width} 0 ${
			-4.5 + this.$props.width
		} 20 ${-10 + this.$props.width} 20`;
		this.polygonPointsAddWidth = polygonPointList;
		const viewBoxList = `0 0 ${21 + this.$props.width} 20`;
		this.viewBoxAddWidth = viewBoxList;
	},
};
</script>

<style scoped>
svg {
	display: inline-block;
	vertical-align: baseline;
	margin-bottom: -2px; /* yes, I'm that particular about formatting */
	width: 50px;
	bottom: 0;
	left: 0;
	position: absolute;
}
</style>
